import {Location} from "react-router-dom";

export default function parseDishUrl(
  location: Location
): [boolean, string, string] {
  const matches = location.pathname.match(/^\/([^/]+)\/([^/]+)\/?$/);

  if (!matches) {
    return [false, "", ""];
  }

  return [true, matches[1], matches[2]];
}
